import { z } from 'zod';
import { subscriptionBillingCadenceSchema } from '../partner-subscription-management/subscriptionBillingCadence.js';
import { subscriptionPaymentMethodSchema } from '../partner-subscription-management/subscriptionPaymentMethod.js';
export const validationTicketPageItemSubscriptionSchema = z.object({
    planName: z.string(),
    billingCadence: subscriptionBillingCadenceSchema,
    paymentMethod: subscriptionPaymentMethodSchema,
});
